module.exports = __webpack_public_path__ + "static/media/payment-method-1.ff991eb0.svg";